import { render, staticRenderFns } from "./SignClaim.vue?vue&type=template&id=40bb81ea&scoped=true"
import script from "./SignClaim.vue?vue&type=script&lang=js"
export * from "./SignClaim.vue?vue&type=script&lang=js"
import style0 from "./SignClaim.vue?vue&type=style&index=0&id=40bb81ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bb81ea",
  null
  
)

export default component.exports